import {auth, url, post} from "../../app/services/Backend/HttpRequest"

export default {
  namespaced: true,
  state(){
    return {
      prices: {
        period: {
          loaded: false,
          data: {
            spot: [],
            actual: [],
            company: [],
            labels: []
          },
        },
        trend: {
          loaded: false,
          data: {
            spot: [],
            market: [],
          }
        }
      }
    }
  },
  mutations: {
    period(state, payload) {
      state.prices.period.loaded = true
      state.prices.period.data = payload
    },

    trend(state, payload) {
      state.prices.trend.loaded = true
      state.prices.trend.data = payload
    },
  },
  actions: {
    period({rootState, commit}, payload){

      const input = {
        url: url('auth/statistics/price/period'),
        payload,
        headers: auth(rootState)
      }

      return post(input).then(response => commit('period', response.data))
    },

    trend({rootState, commit}, payload){

      const input = {
        url: url('auth/statistics/price/trend'),
        payload,
        headers: auth(rootState)
      }

      return post(input).then(response => commit('trend', response.data))
    },
  },
  getters: {
    getTrendForScale: state => (type, scale) => state.prices.trend.data[type].find(item => item.scale === scale)
  },
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/statistics.js